export default "__VITE_ASSET__DxIWVBzB__"